var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-6 mt-2 " }, [
    _c("div", { staticClass: "border-bottom" }, [_vm._t("headline")], 2),
    _vm._v(" "),
    _vm.filterTrainingsList.length !== 0
      ? _c(
          "ul",
          { staticClass: "list-group list-group-flush" },
          _vm._l(_vm.filterTrainingsList, function(item) {
            return _c(
              "li",
              {
                staticClass:
                  "list-group-item d-flex justify-content-between align-items-center"
              },
              [
                _c("div", [
                  _c("p", { staticClass: "m-0" }, [
                    _c("strong", [_vm._v("Training:")]),
                    _vm._v(" " + _vm._s(item.trainingsText) + " | "),
                    _c("strong", [_vm._v("Anzahl:")]),
                    _vm._v(" " + _vm._s(item.attendees) + "\n                ")
                  ]),
                  _vm._v(" "),
                  item.comment !== ""
                    ? _c("p", { staticClass: "m-0" }, [
                        _c("strong", [_vm._v("Kommentar:")]),
                        _vm._v(
                          " " + _vm._s(item.comment) + "\n                "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger btn-sm",
                    on: {
                      click: function($event) {
                        return _vm.emitDeleteTraining(item.unique_id)
                      }
                    }
                  },
                  [_c("i", { staticClass: "far fa-trash-alt" })]
                )
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "list-group list-group-flush" },
          [_vm._t("empty-list-text")],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }